module.exports = __webpack_public_path__ + "static/media/NursesDoctors.48d4a15a.svg";